import { useCallback } from 'react';
import { clipPlaybackStore } from './store';
import { useVideoPlayer } from '../../../video/hooks';
import { Utterance } from '../clip/types';

export const useClipPlayback = () => {
  const state = clipPlaybackStore();
  const { ready, play, isPlaying, currentTime, duration } = useVideoPlayer();

  const playMessage = useCallback((utterance: Utterance) => {
    play(utterance.startTime);
    state.messagePlayingChanged(utterance.id);
  }, []);

  return {
    ready,
    isPlaying,
    play,
    currentTime,
    duration,
    playMessage,
    messageIdPlaying: state.messageIdPlaying,
    changeMessagePlaying: state.messagePlayingChanged,
    autoScroll: state.autoScroll,
    changeAutoScroll: state.autoScrollingChanged,
  };
};
